/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import get from "lodash/get";
import omit from "lodash/omit";
import { connect } from "react-redux";
import LoadingSpinner from "components/LoadingSpinner";
import { useParams } from "react-router-dom";
import JsonEditor from "components/modify/JsonEditor";
import Preview from "components/modify/Preview";
import Save from "components/modify/Save";
import Ajv from "ajv";
import {
  getEditableEventAction,
  setEditableEventAction,
  getAllUsersAction,
} from "store/actions";
import schema from "components/modify/JsonEditorSchema";
import ChangeEditors from "components/modify/ChangeEditors";
import Blades from "components/common/Blades";
import { modifyDocumentTitle } from "components/utils";
import HiddenOn from "components/common/HiddenOn";
import NotFound from "components/NotFound";
import { removeChildrenProperty, readdChildrenProperty } from "utils";

export interface IRouteParams {
  id: string;
}

export const EditPage = ({
  event,
  getAllValidMissionMakers,
  validMissionMakers,
  missionEditors,
  setEditableEvent,
  getEditableEvent,
  error,
  loading,
}: any) => {
  let { id } = useParams<IRouteParams>();

  function setMissionToState(mission) {
    setMission(removeChildrenProperty(mission));
  }

  //actual mission data that will be sent to api
  const [mission, setMission]: any = useState({});

  //List of editors, is concatted to mission above when saving
  //default is admin and the user making the mission
  const [editors, setEditors] = useState([]);

  //Fetches the event and saves it to state
  useEffect(() => {
    getEditableEvent(id);
  }, [id]);

  //saves the current editors of the mission to state
  //is called when "event" changes after the above useEffect is called
  useEffect(() => {
    setMissionToState(event);
    setEditors(missionEditors);
  }, [event]);

  //gets all of the valid mission makers that have accounts
  useEffect(() => {
    getAllValidMissionMakers();
  }, [id]);

  //Set title
  useEffect(() => {
    modifyDocumentTitle("Edit Mission");
  }, []);

  //initialise schema validator
  const ajv = new Ajv({ allErrors: true, verbose: true });

  const content = [
    {
      component: (
        <JsonEditor
          event={mission}
          saveEvent={setMissionToState}
          ajv={ajv}
          schema={schema}
          defaultMissionSelection={event}
        />
      ),
      title: "SCHEMA_TREE",
    },
    {
      component: (
        <JsonEditor
          event={mission}
          saveEvent={setMissionToState}
          ajv={ajv}
          schema={schema}
          defaultMissionSelection={event}
          mode={"text"}
        />
      ),
      title: "SCHEMA_CODE",
    },
    {
      component: <Preview event={readdChildrenProperty(mission)} />,
      title: "PREVIEW",
    },
    {
      component: (
        <ChangeEditors
          validMissionMakers={validMissionMakers}
          editors={editors}
          setEditors={setEditors}
          username={""} //left blank so that you can remove yourself, todo add warning
        />
      ),
      title: "EDITORS",
    },
    {
      component: (
        <Save
          mission={mission}
          ajv={ajv}
          createEvent={setEditableEvent}
          editors={editors}
          confirmationModalText={<div>Are you sure you want to save?</div>}
        />
      ),
      title: "SAVE",
    },
  ];

  return (
    <HiddenOn hideOn={loading} fallback={<LoadingSpinner />}>
      <HiddenOn
        hideOn={error}
        fallback={
          <NotFound text={"There was a problem, try refreshing the page."} />
        }
      >
        <Blades content={content} />
      </HiddenOn>
    </HiddenOn>
  );
};

const mapStateToProps = (state) => ({
  error: get(state, "rootReducer.orbat.editing.error"),
  loading: get(state, "rootReducer.orbat.editing.loading"),
  event: omit(get(state, "rootReducer.orbat.editing.event"), [
    "filled_slots",
    "total_slots",
    "editors",
  ]),
  missionEditors: get(state, "rootReducer.orbat.editing.event.editors", []).map(
    (i) => i.username
  ),
  validMissionMakers: get(state, "rootReducer.core.users.userList", []).map(
    (i) => i.username
  ),
});

const mapDispatchToProps = {
  getEditableEvent: getEditableEventAction,
  setEditableEvent: setEditableEventAction,
  getAllValidMissionMakers: getAllUsersAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPage);
